(function ($) {


    /*
    $("input[name='gender']").on("click", function() {
     alert($(this).val());
 });*/
 
   $( ".gm-themeswitcher input" ).change(function() { 
     var value = $(this).val()
     $('body').attr('data-color',value);
     Cookies.set('color', value, { expires: 7 })
   });
 
   // Prevent overscroll
   // $('.ptx-primarynav-content').scrollLock();
   
   		//.ptx-coursenav button
       /*
		$( ".action-coursenav" ).on( "click", function() {
			var overlay = $( ".ptx-site").attr("data-overlay");
			var state = (overlay == "none") ? "coursenav" : "none";
			$( ".ptx-site").attr("data-overlay",state);
		});
    */

    /*
   $( ".action-slidenav" ).on('click',function() {
      var action = $(this).attr('data-menu');
      var overlay = $( ".ptx-site").attr("data-overlay");

      // alert("Action is " + action);

      var state = (overlay != action) ? action : "none";
      // var navIsShowing = $('.gm-bignav').hasClass('gm-bignav--showing');
      var navIsShowing = state == action;
      $( ".ptx-site").attr("data-overlay",state);

     if(navIsShowing){
      // $('body').addClass('noscroll');
       ptxStdLib.setNavOpen(true);
     } else {
       // $('body').removeClass('noscroll');
       ptxStdLib.setNavOpen(false);
     }
 
  
    // const targetElement = document.querySelector("#someElementId");
 
     // 2. ...in some event handler after showing the target element...disable body scroll
    // bodyScrollLock.disableBodyScroll(menuArea);
 
     // 3. ...in some event handler after hiding the target element...
    // bodyScrollLock.enableBodyScroll(targetElement);
 
     // 4. Useful if we have called disableBodyScroll for multiple target elements,
     // and we just want a kill-switch to undo all that.
    //bodyScrollLock.clearAllBodyScrollLocks();
 
   
   });
  */
   /*
   var zoom = document.documentElement.clientWidth / window.innerWidth;
   $(window).resize(function() {
       var zoomNew = document.documentElement.clientWidth / window.innerWidth;
       if (zoom != zoomNew) {
           // zoom has changed
           // adjust your fixed element
           zoom = zoomNew
       }
        console.log('zoomzoom');
   });

   $(window).on('*', function(event) {
     console.log('did something', event);
  });
*/


   
   /* delect change in page template 
   https://developer.wordpress.org/block-editor/developers/block-api/block-templates/
   $('.editor-page-attributes__template select').on('change',function(){
     console.log($(this).val());
   });
   */


   //  https://codepen.io/iamtimsmith/pen/WzRwNa */
  window.addEventListener("scroll", () => {
    let scrollTop = window.scrollY;
    let docHeight = document.body.offsetHeight;
    let winHeight = window.innerHeight;
    let scrollPercent = scrollTop / (docHeight - winHeight);
    let scrollPercentRounded = Math.round(scrollPercent * 100);
    let scrollPercentDecimal = scrollPercentRounded / 100;
    let scrollPercentageMaxed = scrollPercentDecimal > 1 ? 1 : scrollPercentDecimal;
    var progressBar = $('progress');
    progressBar.attr('value', scrollPercentageMaxed);
    // console.log(scrollPercentageMaxed);
    // document.title = `(${scrollPercentRounded}%) ${originalTitle}`;
  });

  var options = {
    // vertical offset in px before element is first unpinned
    offset : 0,
    // or you can specify offset individually for up/down scroll
    offset: {
        up: 100,
        down: 50
    },
    // scroll tolerance in px before state changes
    tolerance : 0,
    // or you can specify tolerance individually for up/down scroll
    tolerance : {
        up : 5,
        down : 0
    },
    // css classes to apply
    classes : {
        // when element is initialised
        initial : "ptx-primarynav",
        // when scrolling up
        pinned : "ptx-primarynav--pinned",
        // when scrolling down
        unpinned : "ptx-primarynav--unpinned",
        // when above offset
        top : "ptx-primarynav--top",
        // when below offset
        notTop : "ptx-primarynav--not-top",
        // when at bottom of scroll area
        bottom : "ptx-primarynav--bottom",
        // when not at bottom of scroll area
        notBottom : "ptx-primarynav--not-bottom",
        // when frozen method has been called
        frozen: "ptx-primarynav--frozen",
        // multiple classes are also supported with a space-separated list
        pinned: "ptx-primarynav--pinned"
    },
    // element to listen to scroll events on, defaults to `window`
    // scroller : someElement,
    // callback when pinned, `this` is headroom object
    onPin : function() {},
    // callback when unpinned, `this` is headroom object
    onUnpin : function() {},
    // callback when above offset, `this` is headroom object
    onTop : function() {},
    // callback when below offset, `this` is headroom object
    onNotTop : function() {},
    // callback when at bottom of page, `this` is headroom object
    onBottom : function() {},
    // callback when moving away from bottom of page, `this` is headroom object
    onNotBottom : function() {}
};

if(false){
  $(".ptx-primarynav").headroom(options);
}

// enableScrollMonitoring();

})(jQuery);
   
   

function enableScrollMonitoring(){

  const header = document.querySelector('.ptx-primarynav')
  const sections = [...document.querySelectorAll('.wp-block-xx-styled')]
  const scrollRoot = document.querySelector('[data-scroller]')

  let prevYPosition = 0
  let direction = 'up'

  const options = {
    // root: scrollRoot,
    rootMargin: `${header.offsetHeight * -1}px`,
    threshold: 0
  }

  const getTargetSection = (entry) => {
    const index = sections.findIndex((section) => section == entry.target)
    
    if (index >= sections.length - 1) {
    return entry.target
    } else {
    return sections[index + 1]
    }
  }

  const updateColors = (target, i) => {

    var theme = $(target).attr('data-theme');
    var style = $(target).attr('style');
    const computedStyle = getComputedStyle(target);
    var keycolor = computedStyle.backgroundColor;
    console.log("theme, style, computedStyle, keycolor", theme, style, computedStyle, keycolor);

    $('.ptx-primarynav').attr('style',style).attr('data-theme',theme);
      document.querySelector('meta[name="theme-color"]').setAttribute('content',  keycolor); // '#' + 
    /*
    // console.log("beepy is ", target, i);
    var current = sections[i];
    console.log(current);
    const theme = target.dataset.section
    header.setAttribute('data-theme', theme)
    */
  }

  const shouldUpdate = (entry) => {
    return true
 
    /*
    if (direction === 'down' && !entry.isIntersecting) {
      return true
    }

    if (direction === 'up' && entry.isIntersecting) {
      return true
    }
    
    return false
    */
  }

  const onIntersect = (entries, observer) => {
    console.log("entries", entries);
    /*
    // console.log("beep");
    entries.forEach((entry, i) => {
      if (window.scrollTop > prevYPosition) {
        direction = 'down'
      } else {
        direction = 'up'
      }
      
      prevYPosition = window.scrollTop
      
      const target = direction === 'down' ? getTargetSection(entry) : entry.target
      
      if (shouldUpdate(entry)) {
        updateColors(target, i)
      }
    })
    */
   ptxStdLib.handleScrollAnimation();
  }

  const observer = new IntersectionObserver(onIntersect, options)

  sections.forEach((section) => {
    observer.observe(section)
  })


}